import { TrashIcon } from '@heroicons/react/24/outline';
import { observer } from 'mobx-react';

interface Props {
  open: () => void;
}

function OpenButton({ open }: Props) {
  return (
    <button onClick={open} aria-label="Delete section">
      <TrashIcon className="h-5 w-5" />
    </button>
  );
}

export default observer(OpenButton);
